module.exports = __webpack_public_path__ + "img/microservice_architecture.e636f1fd.gif";